import {
  Flex,
  IconHeartFilled,
  IconHeartOutline,
  Colors,
} from '@banhala/ui-kit';
import type { AnyObject } from '../../../../../types';
import { useFavoriteMarket } from '../../../../../hooks';

interface FavoriteButtonProps {
  sno: number;
  isFavorited: boolean;
  logging: AnyObject;
  size?: number;
  uncheckedColor?: string;
  testID: string;
}

export const FavoriteButton = ({
  sno,
  isFavorited: initialFavorited,
  logging,
  size = 40,
  uncheckedColor = Colors.content_pink_primary,
  testID,
}: FavoriteButtonProps) => {
  const { isFavorited, toggleFavorite } = useFavoriteMarket({
    sno,
    initialFavorited,
    logging,
  });

  const iconSize = 24;

  return (
    <Flex.Center
      width={size}
      height={size}
      onPress={toggleFavorite}
      testID={testID}
    >
      {isFavorited ? (
        <IconHeartFilled
          width={iconSize}
          height={iconSize}
          fill={Colors.content_pink_primary}
        />
      ) : (
        <IconHeartOutline
          width={iconSize}
          height={iconSize}
          fill={uncheckedColor}
        />
      )}
    </Flex.Center>
  );
};
